import { render, staticRenderFns } from "./add-list-customer.vue?vue&type=template&id=78d164f2&"
import script from "./add-list-customer.vue?vue&type=script&lang=ts&"
export * from "./add-list-customer.vue?vue&type=script&lang=ts&"
import style0 from "./add-list-customer.vue?vue&type=style&index=0&id=78d164f2&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports